import { useNotification } from '@/core'
import type { BaseServiceOptions, Pagination } from '@/core/types'
import { TDashboard, TDashboardDinamic } from '@/modules/dashboard/types'
import { useQuery } from '@tanstack/vue-query'
import { AxiosError } from 'axios'
import { dashboardDinamicServiceHandler, moduleServiceHandlers } from '../../..'

export const useModuleQuery = (options: BaseServiceOptions<Pagination>) => {
  const { currentPage, enableQuery, filters } = options
  const { errorHttpNotification } = useNotification()

  const loadRecords = useQuery<TDashboard, AxiosError>(
    ['dashboard', currentPage, filters?.loadRecords],
    () =>
      moduleServiceHandlers.loadRecords({
        dynamicFilters: filters?.loadRecords,
        page: currentPage,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: enableQuery?.loadRecords ?? false,
      onError: (error) => errorHttpNotification(error),
    },
  )
  const loadDinamicRecords = useQuery<TDashboardDinamic, AxiosError>(
    ['dashboard-dinamic', filters?.loadDinamicRecords],
    () =>
      dashboardDinamicServiceHandler.loadRecords({
        dynamicFilters: filters?.loadDinamicRecords,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: enableQuery?.loadDinamicRecords ?? false,
      onError: (error) => errorHttpNotification(error),
    },
  )
  return {
    loadRecords,
    loadDinamicRecords,
  }
}
